import { lazy, Suspense } from "react";
import { LinearProgress } from "@mui/material";
import { createBrowserRouter, Navigate } from "react-router-dom";

import lazyCatcher from "utils/lazyCatcher";
import ProtectedLayout from "components/ProtectedLayout";
import AuthLayout from "components/AuthLayout";

const Home = lazy(() => lazyCatcher(() => import(/* webpackPrefetch: true */ "pages/Home")));
const FormSuccess = lazy(() => lazyCatcher(() => import(/* webpackPrefetch: true */ "pages/FormSuccess")));
const Login = lazy(() => lazyCatcher(() => import(/* webpackPrefetch: true */ "pages/Login")));
const Dashboard = lazy(() => lazyCatcher(() => import(/* webpackPrefetch: true */ "pages/Dashboard")));

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<LinearProgress sx={{ position: "absolute", top: 0, width: 1 }} />}>
        <AuthLayout>
          <Login />
        </AuthLayout>
      </Suspense>
    ),
  },
  {
    path: "/form",
    element: (
      <Suspense fallback={<LinearProgress sx={{ position: "absolute", top: 0, width: 1 }} />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/form-success",
    element: (
      <Suspense fallback={<LinearProgress sx={{ position: "absolute", top: 0, width: 1 }} />}>
        <FormSuccess />
      </Suspense>
    ),
  },
  {
    path: "/form-g",
    element: (
      <Suspense fallback={<LinearProgress sx={{ position: "absolute", top: 0, width: 1 }} />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/form-success-g",
    element: (
      <Suspense fallback={<LinearProgress sx={{ position: "absolute", top: 0, width: 1 }} />}>
        <FormSuccess />
      </Suspense>
    ),
  },
  {
    path: "/form-tt",
    element: (
      <Suspense fallback={<LinearProgress sx={{ position: "absolute", top: 0, width: 1 }} />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/form-success-tt",
    element: (
      <Suspense fallback={<LinearProgress sx={{ position: "absolute", top: 0, width: 1 }} />}>
        <FormSuccess />
      </Suspense>
    ),
  },
  {
    path: "/login",
    element: <Navigate to="/" />,
  },
  {
    path: "/dashboard",
    element: (
      <Suspense fallback={<LinearProgress sx={{ position: "absolute", top: 0, width: 1 }} />}>
        <ProtectedLayout>
          <Dashboard />
        </ProtectedLayout>
      </Suspense>
    ),
  },
  { path: "*", element: <Navigate to="/" /> },
]);

export default router;
